import type { ReactElement } from 'react';

import { create } from 'zustand';

import type { ModalDefinitions, ModalKey } from '../modals/modals';

type ModalInstance = {
  id: string;
  action: ModalKey;
  render: (definitions: ModalDefinitions) => ReactElement;
  dismiss: () => void;
};

type ModalState = {
  stack: ModalInstance[];
  push: (instance: ModalInstance) => void;
  remove: (id: string) => void;
};

export const useModalStore = create<ModalState>((set) => ({
  stack: [],
  push(instance) {
    set((s) => ({ stack: [...s.stack, instance] }));
  },
  remove(id) {
    set((s) => ({ stack: s.stack.filter((m) => m.id !== id) }));
  },
}));
